import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation
} from "@angular/core";
import { CerrixButtonComponent } from "@app/shared/atoms/cerrix-button/cerrix-button.component";

@Component({
    selector: "app-toggle-group",
    templateUrl: "./toggle-group.component.html",
    styleUrls: ["./toggle-group.component.scss"],
    standalone: true,
    imports: [
        CerrixButtonComponent
    ],
    encapsulation: ViewEncapsulation.None
})
export class ToggleGroupComponent {
    @Input() options: { label: string; value: string, count?: number }[] = [];
    @Input() selectedValue!: string;
    @Output() selectedValueChange = new EventEmitter<string>();

    onOptionClick(option: { label: string; value: string, count?: number }): void {
        this.selectedValue = option.value;
        this.selectedValueChange.emit(option.value);
    }
}